import { h } from 'preact';

import Grid from '@mui/material/Grid';

import LazyClsUrlIssueDetail from './lazyUrlIssueDetail.jsx';

export default function LazyClsUrlIssueDetails(_props) {
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12}>
        <LazyClsUrlIssueDetail />
      </Grid>
    </Grid>
  );
}
